import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import ImpactCounters from './components/ImpactCounters';
import CampaignCategories from './components/CampaignCategories';
import FeaturedCampaigns from './components/FeaturedCampaigns';
import HowItWorks from './components/HowItWorks';
import WhyChooseUs from './components/WhyChooseUs';
import SuccessStories from './components/SuccessStories';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import OurPrograms from './components/OurPrograms';
import CtaSection from './components/CtaSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <ImpactCounters />
        <CampaignCategories />
        <FeaturedCampaigns />
        <HowItWorks />
        <WhyChooseUs />
        <SuccessStories />
        <GallerySection />
        <TestimonialsSection />
        <OurPrograms />
        <CtaSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}